import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService, UserService } from 'app/services';
import { Jsonp, RequestOptions, Http, Headers, ResponseContentType } from '@angular/http';
import { environment } from 'environments/environment';

@Injectable()
export class GiaoNhan110Service {
  data: any = {};
  datanew: any = {};
  constructor(private router: Router, private api: ApiService, private http: Http, private user: UserService) {
  }
  APIURL = "api/ExcuteOracle";
  APIURL_FILE = "api/Files";
  APIURL_CMIS = "api/GiaoNhan110";

  uploadFile(desFolder: string, overWrite: string, fileList: FileList) {
    return this.api.uploadFile(this.APIURL_FILE, desFolder, overWrite, fileList);
  }
  uploadExcelReturnJson(desFolder: string, overWrite: string, file: File) {
    let formData: FormData = new FormData();
    formData.append('uploadFile', file, file.name);
    formData.append('Desfolder', desFolder);
    formData.append('overWrite', overWrite);
    let headers = new Headers()
    //headers.append('Content-Type', 'json');  
    //headers.append('Accept', 'application/json');  
    let options = new RequestOptions({ headers: headers });
    return this.api.Excute("api/GiaoNhan110/UploadExcelReturnJson", formData, options);
  }
 
  Json2ExcelFile(json: string, filename: string, tablename: string, tableschema: string) {
    let formData: FormData = new FormData();
    formData.append('jsondata', json);
    formData.append('filename', filename);
    formData.append('tablename', tablename);
    formData.append('tableschema', tableschema);
    //return this.http.post(ROOT_URL + "api/Cmis/Json2XmlFile", formData, options).map(res => res.json());
    return this.api.downloadFile("api/GiaoNhan110/Json2ExcelFile", formData, filename);
  }

  getDataCmissBulk(namesql, mataikhoan, thoidiem, jsonData, sudung_hsn, ip) {

    let formData: FormData = new FormData();
    formData.append('namesql', namesql);
    formData.append('jsondata', jsonData);
    formData.append('thoidiem', thoidiem);
    formData.append('mataikhoan', mataikhoan);
    formData.append('sudung_hsn', sudung_hsn);
    formData.append('ip', ip);

    let headers = new Headers()
    let options = new RequestOptions({ headers: headers });

    return this.api.Excute("api/GiaoNhan110/GetDataCmisBulk", formData, options);
  }



}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/tien-ich/giao-nhan-110/giaonhan110.service.ts